import emptySliceApi from '../../store/emptyApiSlice';
import { AlertMessage } from './models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccountAlerts: builder.query<AlertMessage[], string>({
      query: (accountId) => `v4/accounts/${accountId}/alerts`,
      providesTags: ['AccountAlerts'],
    }),
  }),
});

export const { useGetAccountAlertsQuery } = apiSlice;
